import { React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type UniversePreviewDateComparisonProps = {
  id: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: DraftParams) => void;

  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'universe_date_comparison', string>;
  goFullScreen?: (_b: string) => void;
  fullScreen?: boolean;
  context?: ts.types.universe.UniversePreviewContext;
  queryParams?: { initial?: string };
};

const UniversePreviewDateComparison = ({
  id,
  loadWidgetData,
  widgetPaths,
  mode,
  context,
  params,
  setParams,
  fullScreen,
  goFullScreen,
  queryParams,
}: UniversePreviewDateComparisonProps) => {
  const renderJobComponent = () => (
    <>
      <Chart
        id={id}
        loadWidgetData={loadWidgetData}
        dateComparison={widgetPaths['universe_date_comparison']}
        fullScreen={fullScreen}
        context={context}
        queryParams={queryParams}
        goFullScreen={goFullScreen}
        params={params as Params}
        setParams={setParams}
      />
    </>
  );

  return (
    <>
      {mode == 'edit' ? (
        <Form
          params={params}
          setParams={setParams}
          universeStartDate={context?.start_date}
          universeEndDate={context?.end_date}
          universeCountries={context?.definition?.quotation_countries ?? []}
        />
      ) : (
        renderJobComponent()
      )}
    </>
  );
};

export default UniversePreviewDateComparison;
